<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

const open = ref(false)
let closeTimer: ReturnType<typeof setTimeout> | undefined

function onEnter() {
  clearTimeout(closeTimer)
  open.value = true
}

function onLeave() {
  closeTimer = setTimeout(() => {
    open.value = false
  }, 120)
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape') {
    open.value = false
  }
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onUnmounted(() => {
  window.removeEventListener('keydown', onKeydown)
  clearTimeout(closeTimer)
})
</script>

<template>
  <div
    class="relative inline-flex"
    tabindex="0"
    :aria-expanded="open"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
    @focusin="onEnter"
    @focusout="onLeave"
  >
    <slot />
    <div
      v-if="open"
      class="absolute bottom-full left-0 z-50 mb-1.5 min-w-[200px] rounded-md border bg-popover p-0 text-popover-foreground shadow-md"
      role="tooltip"
      @mouseenter="onEnter"
      @mouseleave="onLeave"
    >
      <slot name="content" />
    </div>
  </div>
</template>
